const formatFiltresToAxiosParams = function (filtres) {
  let params = ''

  if (filtres.typeExploitation) {
    params += `filtreTypeExploitation=${filtres.typeExploitation.code}&`
  }
  if (filtres.typeProduction) {
    params += `filtreTypeProduction=${filtres.typeProduction.code}&`
  }
  if (filtres.potentielSol) {
    params += `filtrePotentielSol=${filtres.potentielSol.code}&`
  }
  if (filtres.ressourceEffluents) {
    params += `filtreRessourceEffluents=${filtres.ressourceEffluents.code}&`
  }
  if (filtres.stockeur) {
    params += `filtreStockeur=${filtres.stockeur.code}&`
  }
  if (filtres.regionsAgrial != null && filtres.regionsAgrial.length && filtres.regionsAgrial[0] != null) {
    if (Array.isArray(filtres.regionsAgrial)) {
      params += `${formatFiltresRegionsArrayToAxiosParams(filtres.regionsAgrial)}&`
    } else {
      params += `filtreCodesRegions=${filtres.regionsAgrial.codeRegion}&`
    }
  }

  //enlève le dernier &
  return params.slice(0, -1)
}

const formatFiltresRegionsArrayToAxiosParams = function (filtreRegions) {
  let params = 'filtreCodesRegions='
  filtreRegions.forEach(region => {
    if (region != null && region.codeRegion != null) {
      params += `${region.codeRegion},`
    }
  })
  //enlève la dernière virgule
  return params.slice(0, -1)
}

export { formatFiltresToAxiosParams }
